import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Spin } from 'antd'
import { useAdminAuth } from '@/context/AdminAuthContext'

export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { status } = useAdminAuth()
  const location = useLocation()

  if (status === 'loading') {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '6rem' }}>
        <Spin />
      </div>
    )
  }

  if (status === 'unauthenticated') {
    const from = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/admin/login?from=${from}`} replace />
  }

  return <>{children}</>
}
